import React from "react";

export const Layout = props => (
  <div className="bg-default">
    <section>{props.children}</section>
  </div>
);
